// @ts-nocheck

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

import { ModalContentSpacing } from '../../constants/ui/modal';
import { getPortalRootDOMElement } from '../../DOMElements';
import useRouter from '../../hooks/useRouter';
import BoomRouterSwitch from '../../modules/boom/components/BoomRouterSwitch';
import GRRouterSwitch from '../../modules/gift-race/components/GRRouterSwitch';
import KLRouterSwitch from '../../modules/koh-lanta/components/KLRouterSwitch';
import MPRouterSwitch from '../../modules/monopoly/components/MPRouterSwitch';
import { Modal as ModalTheme } from '../../styled-components/dark/modal';
import { type Licence, Licences } from '../../types/common';
import { getUserhasConnected } from '../../utils/userStorage';
import Modal from '../Modal';
import RegisterModal from '../RegisterModal';
import ScaleRouteTransitionGroup from '../ScaleRouteTransitionGroup';
import SportRadarPlayerWidgetContainer from '../SportRadarPlayerWidget/SportRadarPlayerWidgetContainer';
import SportRadarWidget from '../SportRadarWidget';

type DesktopBettingModalLayoutProps = {
  licence: Licence;
  connected: boolean;
  openExternalLink: () => void;
};

const DesktopBettingModalLayout = ({ connected, openExternalLink, licence }: DesktopBettingModalLayoutProps) => {
  const { history, location } = useRouter();
  const isSrPlayerWidgetOpen = location.state?.playerWidgetProps;
  const isBrWidgetOpen = location.state?.brWidgetProps;
  const hasConnected = useMemo(() => getUserhasConnected(), []);
  const [showRegisterModal, setShowRegisterModal] = useState(
    !hasConnected && !connected && [Licences.DE, Licences.FR].includes(licence),
  );

  // Lorsqu'on est authentifié via le poker, si on voit qu'un des 2 flags de connexion change, on enlève la modale
  useEffect(() => {
    if (hasConnected || connected) {
      setShowRegisterModal(false);
    }
  }, [hasConnected, connected]);

  // Used to stay on current page when closing betshare (goBack would send to betting home)
  const removeLocationHash = useCallback(() => {
    history.goBackOrReplace(location.pathname);
  }, [history, location.pathname]);

  return createPortal(
    <>
      <KLRouterSwitch key="kl-router-switch" />
      <GRRouterSwitch key="gr-router-switch" />
      <MPRouterSwitch key="mp-router-switch" />
      <BoomRouterSwitch key="boom-router-switch" />

      <ScaleRouteTransitionGroup>
        {isSrPlayerWidgetOpen ? (
          <Modal
            backgroundColor={ModalTheme.backgroundColor.widgetPlayer}
            className="overrideTrackerCss"
            closeOnOutsideClick
            closeOnEsc
            hasCloseButton
            hasOverlay
            onClose={removeLocationHash}
            useViewportSize
          >
            <SportRadarPlayerWidgetContainer
              matchId={location.state?.playerWidgetProps.matchId}
              playerSrId={location.state?.playerWidgetProps.playerSrId}
              playerTeam={location.state?.playerWidgetProps.playerTeam}
            />
          </Modal>
        ) : null}

        {isBrWidgetOpen ? (
          <Modal
            backgroundColor={ModalTheme.backgroundColor.brDesktopWidget}
            closeOnOutsideClick
            closeOnEsc
            hasCloseButton
            hasOverlay
            onClose={removeLocationHash}
            useViewportSize
          >
            <SportRadarWidget
              displayWidget={isBrWidgetOpen}
              commandKey={location.state?.brWidgetProps.commandKey}
              options={location.state?.brWidgetProps.widgetOptions}
            />
          </Modal>
        ) : null}

        {/* Register Modal */}
        {showRegisterModal ? (
          <Modal
            backgroundColor={ModalTheme.backgroundColor.default}
            contentSpacing={ModalContentSpacing.NONE}
            closeOnEsc
            hasCloseButton
            onClose={() => setShowRegisterModal(false)}
            hasOverlay
          >
            <RegisterModal openExternalLink={openExternalLink} onClose={() => setShowRegisterModal(false)} />
          </Modal>
        ) : null}
      </ScaleRouteTransitionGroup>
    </>,
    getPortalRootDOMElement(),
  );
};

export default DesktopBettingModalLayout;
